import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Logo extends Vue {
  protected get headerLogoSrc(): string {
    if (this.$route.params.screening === undefined) {
      // Load a default logo instead
      return '';
    }
    const suName = this.$route.params.screening.toLowerCase();

    const svg = [];
    const jpg = ['tg'];
    const png = ['beso', 'bb', 'sg', 'vd'];

    /**
     * On emploie le format png transparent
     */
    if (png.includes(suName)) {
      return require(`@/assets/logos/${suName}.png`);
    // Si l'image n'a aucun format alors on prend celle par d�faut
    } else if (jpg.includes(suName)) {
      return require(`@/assets/logos/${suName}.jpg`);
    } else {
      // Load a default logo (same for all SU)
      // eslint-disable-next-line quotes
      return require(`@/assets/logos/default.png`);
    }
  }
}
